import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchKrwRate } from "#/lib/api/price";
import { queryKeys } from "./query-keys";

export function useKrwRate() {
	const queryClient = useQueryClient();
	return useQuery({
		queryKey: queryKeys.fx.krwRate(),
		queryFn: async () => {
			try {
				return await fetchKrwRate();
			} catch (e) {
				if (e instanceof TypeError) {
					const cached = queryClient.getQueryData<number>(
						queryKeys.fx.krwRate(),
					);
					if (cached !== undefined) return cached;
				}
				throw e;
			}
		},
		staleTime: 5 * 60 * 1000,
		refetchInterval: 10 * 60 * 1000,
		gcTime: 5 * 60 * 1000,
	});
}
